<template>
	<PopUp :message="message" :invalid="invalid" :auto-close="true" @close="invalid = false" top="4rem" />
	<div v-if="visible" class="overlay">
		<div class="popup-card">
			<button @click="visible = false" aria-label="Close" class="float-end"
				style="background: transparent; border: none; color: #ccc; font-size: 20px; cursor: pointer;">✕</button>
			<h4 class="mb-3">Enter Verification Code</h4>
			<div class="d-flex justify-content-center mb-3">
				<input maxlength="1" id="1" @keyup="handleInput($event, 2)" ref="ZeroInput" v-model="zero" class="code-input"
					type="text" pattern="[0-9]*" inputmode="numeric" />
				<input maxlength="1" id="2" @keyup="handleInput($event, 3)" v-model="one" class="code-input" type="text"
					pattern="[0-9]*" inputmode="numeric" ref="OneInput" />
				<input maxlength="1" id="3" @keyup="handleInput($event, 4)" v-model="two" ref="TwoInput" class="code-input"
					type="text" pattern="[0-9]*" inputmode="numeric" />
				<input maxlength="1" id="4" @keyup="handleInput($event, 5)" v-model="three" ref="ThreeInput" class="code-input"
					type="text" pattern="[0-9]*" inputmode="numeric" />
				<input maxlength="1" id="5" @keyup="handleInput($event, 6)" class="code-input" v-model="four" ref="FourInput"
					type="text" pattern="[0-9]*" inputmode="numeric" />
			</div>
			<button class="btn btn-primary w-100" @click="verifyCode">Verify</button>
		</div>
	</div>
	<div v-if="loading" class="spinner-overlay d-flex justify-content-center align-items-center">
		<VueSpinnerTail size="60" color="orange" />
	</div>
	<div class="d-flex justify-content-center pt-5 mb-5 hero-background">
		<div class="card p-3 shadow-lg w-60 mx-5"
			style="max-width: 1000px; width: 100%; background: white; border: none; min-height: unset;">
			<h2 class="text-center mb-3 text-black">Sign Up</h2>
			<form ref="formRef" @submit="SignUp" class="needs-validation" novalidate>
				<div class="mb-2">
					<label for="username" class="form-label text-black text-start w-100">Username</label>
					<input v-model="username" type="text" class="form-control bg-dark text-white border-secondary" id="username"
						placeholder="Enter username" style="color: white;" required>
					<div class="invalid-feedback">
						Please specify username.
					</div>
				</div>
				<div class="mb-2">
					<label for="email" class="form-label text-black text-start w-100">Email address</label>
					<input v-model="mail" type="email" class="form-control bg-dark text-white border-secondary" id="email"
						placeholder="Enter email" required>
					<div class="invalid-feedback">
						Please specify email.
					</div>
				</div>
				<div class="mb-2">
					<label for="password" class="form-label text-black text-start w-100">Password</label>
					<input v-model="password" type="password" class="form-control bg-dark text-white border-secondary"
						id="password" placeholder="Enter password" autocomplete="new-password" required>
					<div class="invalid-feedback">
						Please specify password.
					</div>
				</div>
				<button id="sign" class="btn btn-success w-50 mt-2" type="submit"
					style="background-color: yellow;color: black;">Sign Up</button>
			</form>
			<div class="d-flex justify-content-center mt-2">
				<div id="google-signup-button" class="g-signup2"></div>
			</div>
			<div class="text-center mt-2">
				<span class="text-secondary">Already have an account?</span>
				<RouterLink to="/signin" class="ms-2 text-info">Sign In</RouterLink>
			</div>
		</div>
	</div>
	<FoOter />
</template>
<script setup>
import { ref, nextTick, onMounted } from 'vue'
import { get_cookie } from '@/common'
import { VueSpinnerTail } from 'vue3-spinners'
import { BASE_URL } from '../common.js'
import { GOOGLE_ID } from '../common.js'
import FoOter from './Footer.vue'
import PopUp from './PopUp.vue'
let visible = ref(false)
let formRef = ref(null)
let invalid = ref(false)
let message = ref('')
const loading = ref(false);
const username = ref('')
const password = ref('')
const mail = ref('')
const ZeroInput = ref(null)
const OneInput = ref(null)
const TwoInput = ref(null)
const ThreeInput = ref(null)
const FourInput = ref(null)
const zero = ref('')
const one = ref('')
const two = ref('')
const three = ref('')
const four = ref('')
async function status() {
	try {
		const csrf = get_cookie('csrftoken')
		const data = await fetch(`${BASE_URL}/signup`, {
			method: 'GET',
			headers: { 'X-CSRFToken': csrf },
			credentials: 'include'
		});
		const response = await data.json();
		if (response.status === 300 && window.location.pathname !== '/codraw') {
			window.location.href = '/codraw';
		}
	} catch (e) {
		console.error(e);
	}
}
async function SignUp(e) {
	loading.value = true;
	e.preventDefault()
	const form = formRef.value;
	form.classList.add('was-validated')
	if (!form.checkValidity()) {
		e.stopPropagation()
		loading.value = false;
		return;
	}
	const csrf = get_cookie('csrftoken')
	const username_input = username.value
	const password_input = password.value
	const mail_input = mail.value
	try {
		const data = await fetch(`${BASE_URL}/signup`, {
			method: "POST",
			headers: { "Content-Type": 'application/json', 'X-CSRFToken': csrf },
			body: JSON.stringify({
				"username": username_input,
				"mail": mail_input,
				"password": password_input
			}),
			credentials: 'include'
		})
		const response = await data.json()
		loading.value = false;
		if (response.status === 200) {
			visible.value = true
			await nextTick()
			ZeroInput.value.focus()
		} else {
			invalid.value = true
			message.value = "Account already registered under this email. Did you forget your password?"
		}
	} catch (e) {
		console.error(e)
		loading.value = false;
	}
}
function handleInput(event, index) {
	if (event.key.startsWith("Arrow") || !("0123456789".includes(event.key))) return;
	if (event.key === "Backspace" || event.key == "Del") {
		if (index === 3 && !one.value) ZeroInput.value.focus()
		else if (index === 5 && !three.value) TwoInput.value.focus()
		else if (index === 4 && !two.value) OneInput.value.focus()
		else if (index === 6 && !four.value) ThreeInput.value.focus()
	} else {
		if (index === 2 && OneInput.value) OneInput.value.focus()
		else if (index === 3 && TwoInput.value) TwoInput.value.focus()
		else if (index === 4 && ThreeInput.value) ThreeInput.value.focus()
		else if (index === 5 && FourInput.value) FourInput.value.focus()
	}
}

function getCode() {
	return `${zero.value}${one.value}${two.value}${three.value}${four.value}`;
}

async function verifyCode() {
	const csrf = get_cookie('csrftoken')
	const username_input = username.value
	const mail_input = mail.value
	const data = await fetch(`${BASE_URL}/verify`, {
		method: "POST",
		headers: {
			'Content-Type': 'application/json',
			'X-CSRFToken': csrf
		},
		body: JSON.stringify({
			"username": username_input,
			"mail": mail_input,
			"code": getCode(),
		})
	})
	const response = await data.json()
	if (response.status === 200) {
		window.location.href = '/codraw'
	} else {
		visible.value = false
		invalid.value = true
		zero.value = ''
		one.value = ''
		two.value = ''
		three.value = ''
		four.value = ''
		message.value = "Invalid verification code. Please try again- new verification code has been sent.";
	}
}
async function handleCredentialResponse(response) {
	try {
		loading.value = true;
		const csrf = get_cookie('csrftoken');
		// Decode the JWT token to get user info
		const payload = JSON.parse(atob(response.credential.split('.')[1]));
		const data = await fetch(`${BASE_URL}/google-signup`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRFToken': csrf
			},
			credentials: 'include',
			body: JSON.stringify({
				"token": payload.sub,
				"email": payload.email,
				"name": payload.name,
			})
		});
		const result = await data.json();
		if (result.status === 300) {
			window.location.href = '/codraw';
		} else {
			invalid.value = true;
			message.value = 'Google sign-up failed. An account with this email already exists. Did you forget your password?';
		}
	} catch (e) {
		invalid.value = true;
		message.value = 'An error occurred during Google sign-up.';
	} finally {
		loading.value = false;
	}
}
onMounted(() => {
	loading.value = true;
	window.google.accounts.id.initialize({
		client_id: `${GOOGLE_ID}.apps.googleusercontent.com`,
		callback: handleCredentialResponse
	});
	window.google.accounts.id.renderButton(
		document.getElementById("google-signup-button"),
		{
			theme: "outline",
			size: "large",
			text: "signup"
		}
	);
	loading.value = false;
	status();
});
</script>

<style scoped>
.card {
	background: linear-gradient(135deg, #181818 80%, #222 100%);
	color: #fff;
	border-radius: 1.5rem;
	border: 2px solid #ffc107;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35), 0 2px 8px rgba(255, 255, 0, 0.08);
	padding: 2rem 1.5rem;
	margin-top: 1.5rem;
	transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
	box-shadow: 0 12px 36px rgba(255, 255, 0, 0.18), 0 8px 32px rgba(0, 0, 0, 0.45);
}

.card h2 {
	color: #ffc107;
	font-weight: 700;
	letter-spacing: 1px;
	margin-bottom: 1.2rem;
}

.card label {
	color: #ffc107;
	font-weight: 500;
}

.card input {
	background: #222;
	color: #fff;
	border: 1.5px solid #ffc107;
	border-radius: 0.5rem;
	margin-bottom: 0.7rem;
}

.card input:focus {
	border-color: #007bff;
	background: #333;
}

#sign {
	background: linear-gradient(90deg, #ffe066 60%, #ffd700 100%);
	color: #181818;
	font-weight: 700;
	border: none;
	border-radius: 0.7rem;
	box-shadow: 0 2px 8px rgba(255, 255, 0, 0.08);
	transition: background 0.2s, color 0.2s, transform 0.2s;
}

#sign:hover {
	background: #007bff !important;
	color: #fff !important;
	transform: scale(1.05);
}

input::placeholder {
	color: #ccc !important;
	opacity: 1;
}

.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}

.popup-card {
	position: relative;
	background: linear-gradient(135deg, #181818 80%, #222 100%);
	color: #fff;
	padding: 2.5rem 2rem 2rem 2rem;
	border-radius: 1.5rem;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45), 0 2px 8px rgba(255, 255, 0, 0.10);
	min-width: 400px;
	max-width: 90vw;
	text-align: center;
	border: 2px solid #ffc107;
}

.popup-card h4 {
	color: #ffc107;
	font-weight: 700;
	margin-bottom: 1.5rem;
}

.code-input {
	width: 2.5rem;
	height: 2.5rem;
	margin: 0 0.3rem;
	font-size: 2rem;
	text-align: center;
	border: 2px solid #ffc107;
	border-radius: 8px;
	background: #222;
	color: #fff;
	outline: none;
	transition: border 0.2s, background 0.2s;
}

.code-input:focus {
	border-color: #007bff;
	background: #333;
}

.popup-card .btn-primary {
	background: linear-gradient(90deg, #ffe066 60%, #ffd700 100%);
	color: #181818;
	font-weight: 700;
	border: none;
	border-radius: 0.7rem;
	box-shadow: 0 2px 8px rgba(255, 255, 0, 0.08);
	transition: background 0.2s, color 0.2s, transform 0.2s;
	margin-top: 1.2rem;
}

.popup-card .btn-primary:hover {
	background: #007bff !important;
	color: #fff !important;
	transform: scale(1.05);
}

.hero-background {
	background: linear-gradient(180deg, #0a0a0f 0%, #0d0d15 50%, #0a0a0f 100%);
	min-height: 50vh;
	width: 100%;
}

.spinner-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.7);
}
</style>
